var fallbackWindow = {};
export function locateWindow() {
  if (typeof window !== "undefined") {
    return window;
  } else if (typeof self !== "undefined") {
    return self;
  }

  return fallbackWindow;
}